// Copyright (c) 2026 Dyna Robotics, Inc. All rights reserved.
// Dyna Robotics Proprietary and Confidential.
// Unauthorized copying, use, or distribution is prohibited.
// SPDX-License-Identifier: LicenseRef-Dyna-Internal

/**
 * QR codes, for robot SN labels. Drawn as an SVG of the module grid rather than fetched or
 * rendered to a canvas: no request leaves the page, it is sharp at any zoom and when
 * printed, and the markup is ours rather than a string from a library set as HTML. The SN
 * is encoded in the QR alphanumeric mode (digits and capitals are all an SN holds), which
 * keeps the code small enough to scan off a label at arm's length.
 */

import qrcode from "qrcode-generator";

/** Quiet zone, in modules — the white border a scanner needs to find the code. */
const MARGIN = 2;

/** The dark modules as one SVG path, offset by the quiet zone. */
export function qrPath(text: string): { path: string; size: number } {
  const code = qrcode(0, "M");
  code.addData(text, /^[0-9A-Z $%*+\-./:]*$/.test(text) ? "Alphanumeric" : "Byte");
  code.make();
  const count = code.getModuleCount();
  let path = "";
  for (let row = 0; row < count; row++) {
    for (let col = 0; col < count; col++) {
      if (code.isDark(row, col)) path += `M${col + MARGIN} ${row + MARGIN}h1v1h-1z`;
    }
  }
  return { path, size: count + MARGIN * 2 };
}
